module.exports = __webpack_public_path__ + "static/media/Drill_Sgt_Creed4-4.e5b42590.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Drill_Sgt_Creed4-4.svg
// module id = 651
// module chunks = 0